import { AUTH_API_BASE_URL, urlFor, request } from '../index';

export async function getDeposit(params) {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/deposit?${params}`), {
      auth: true
    });
  } catch (e) {
    return e
  }
}

export async function getDeposit2(params) {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/deposit/beta?${params}`), {
      auth: true
    });
  } catch (e) {
    return e
  }
}

export async function addDeposit(data) {
  try {
    return request('post', urlFor(AUTH_API_BASE_URL, '/deposit/add'), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function updateDeposit(data) {
  try {
    return request('patch', urlFor(AUTH_API_BASE_URL, '/deposit/update'), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function getTransfer(params) {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/transfer-money?${params}`), {
      auth: true
    });
  } catch (e) {
    return e
  }
}

export async function addTransfer(data) {
  try {
    return request('post', urlFor(AUTH_API_BASE_URL, `/transfer-money/add`), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function addTransferOut(data) {
  try {
    return request('post', urlFor(AUTH_API_BASE_URL, `/transfer-money/add-transfer-out`), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function updateTransfer(data) {
  try {
    return request('patch', urlFor(AUTH_API_BASE_URL, `/transfer-money/update`), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}


export async function getWithdraw(params) {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/withdraw?${params}`), {
      auth: true
    });
  } catch (e) {
    return e
  }
}

export async function addWithdraw(data) {
  try {
    return request('post', urlFor(AUTH_API_BASE_URL, '/withdraw/add'), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function updateWithdraw(data) {
  try {
    return request('patch', urlFor(AUTH_API_BASE_URL, '/withdraw/update'), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function updateWithdrawTrueWallet(data) {
  try {
    return request('patch', urlFor(AUTH_API_BASE_URL, '/withdraw/update-truewallet'), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function updateWithdrawPaykrub(data) {
  try {
    return request('patch', urlFor(AUTH_API_BASE_URL, '/withdraw/update-paykrub'), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function updateWithdrawCloudpay(data) {
  try {
    return request('patch', urlFor(AUTH_API_BASE_URL, '/withdraw/update-cloudpay'), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function updateWithdrawJompay(data) {
  try {
    return request('patch', urlFor(AUTH_API_BASE_URL, '/withdraw/update-jompay'), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function updateWithdrawHypay(data) {
  try {
    return request('patch', urlFor(AUTH_API_BASE_URL, '/withdraw/update-hypay'), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function updateWithdrawBitpayz(data) {
  try {
    return request('patch', urlFor(AUTH_API_BASE_URL, '/withdraw/update-bitpayz'), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function updateWithdrawHypayV2(data) {
  try {
    return request('patch', urlFor(AUTH_API_BASE_URL, '/withdraw/update-hypay-v2'), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function updateWithdrawApay(data) {
  try {
    return request('patch', urlFor(AUTH_API_BASE_URL, '/withdraw/update-apay'), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function updateWithdrawRitzpay(data) {
  try {
    return request('patch', urlFor(AUTH_API_BASE_URL, '/withdraw/update-ritzpay'), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function updateWithdrawNovapay(data) {
  try {
    return request('patch', urlFor(AUTH_API_BASE_URL, '/withdraw/update-nova'), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function updateWithdrawRitzpay2(data) {
  try {
    return request('patch', urlFor(AUTH_API_BASE_URL, '/withdraw/update-ritzpay-v2'), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function updateWithdrawAutopeer(data) {
  try {
    return request('patch', urlFor(AUTH_API_BASE_URL, '/withdraw/update-autopeer'), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function getAccountBankDeposit() {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/deposit/accountbank`), {
      auth: true
    });
  } catch (e) {
    return e
  }
}

export async function getStampDeposit(params) {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/stamp-deposit?${params}`), {
      auth: true
    });
  } catch (e) {
    return e
  }
}

export async function addDepositGames(data) {
  try {
    return request('post', urlFor(AUTH_API_BASE_URL, '/deposit/add-by-user'), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function cancelDepositGames(data) {
  try {
    return request('delete', urlFor(AUTH_API_BASE_URL, '/stamp-deposit/cancel'), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function updateWithdrawStatus(data) {
  try {
    return request('post', urlFor(AUTH_API_BASE_URL, `/withdraw/update-withdraw-status`), {
      auth: true,
      data
    });
  } catch (e) {
    return e
  }
}

export async function getDetailRefund(params) {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/withdraw/detail-refund?${params}`), {
      auth: true
    });
  } catch (e) {
    return e
  }
}
